<template>
  <div class="container bg-white p-3 flex justify-center flex flex-row" v-for="link in links">
  <p class="truncate text-gray-500">{{link.url}}</p>
  <a :href="link.shorten" target="_blank" class="p-1 text-blue-600">
      {{ link.shorten }}
    </a>
    <button
      v-if="link.shorten"
      @click="copyUrl"
      class="bg-blue-500 mx-4 p-1 rounded copy-button"
    >
      Copy to clipboard
    </button>
  </div>
  
</template>

<script>

export default {
  name: "ShortenedLink",
  props: {
    shorten: String,
    links: Array,
  },
  methods: {
    copyUrl() {
      try {
        navigator.clipboard.writeText(this.shorten);
      } catch (e) {
        throw e;
      }
    },
  },
  
};
</script>

<style scoped></style>
